import { Waypoint } from 'react-waypoint';

import { Carousel } from 'src/app/shared/components/carousel';

import { AutoTaggedPetition } from './components/AutoTaggedPetition/index_new';
import { DecisionMakerRecommendation } from './components/DecisionMakerRecommendation/index_new';
import { EmailDecisionMaker } from './components/EmailDecisionMaker/index_new';
import { FreePromotionNotification } from './components/FreePromotion/index_new';
import { FreePromotionFulfillment } from './components/FreePromotionFulfillment/index_new';
import { NOTIFICATION_TYPES } from './constants';
import { useNotificationsCenter } from './hooks/useNotificationsCenter';

export function NotificationsCenter() {
	const { data, actions } = useNotificationsCenter();

	return (
		<Carousel className="p-6">
			{data.notifications.map((notification) => {
				switch (notification.type) {
					case NOTIFICATION_TYPES.freePromotionFulfillment:
						return (
							<div className="flex h-full w-full" key="free-promotion-fulfillment">
								<FreePromotionFulfillment onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.promotion:
						return (
							<div className="flex h-full w-full" key="free-promo">
								<FreePromotionNotification onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.decisionMakerRecommendation:
						return (
							<div className="flex h-full w-full" key="dm-recommendation">
								<DecisionMakerRecommendation onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.autoTaggedPetition:
						return (
							<div className="flex h-full w-full" key="auto-tagged">
								<AutoTaggedPetition onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);

					case NOTIFICATION_TYPES.emailDecisionMaker:
						return (
							<div className="flex h-full w-full" key="starter-can-email-dm">
								<EmailDecisionMaker onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					default:
						return null;
				}
			})}
		</Carousel>
	);
}
